import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import schema from './schema';
import Api from '../../../../services';
import PhoneField from '../../../../components/phone-input';
import Spinner from '../../../../components/spinner';
import { saveVerificationState } from '../../../../helpers/auth-return';

export default function PhoneForm() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { locale } = useParams();
  const { t } = useTranslation();
  const {
    register, handleSubmit, formState: { errors }, control, setError,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = (data: { phone_number: string }) => {
    setLoading(true);
    Api.accounts.sendOtp({
      username: data.phone_number,
    }).then((response) => {
      setLoading(false);
      saveVerificationState({
        username: data.phone_number,
        data: response.data,
        type: 'mobile',
      });
      navigate(`/${locale}/auth/verify_identity`, {
        state: {
          ...location.state,
          username: data.phone_number,
          data: response.data,
          type: 'mobile',
        },
      });
    }).catch((error) => {
      setLoading(false);
      const responseErrors = error?.response?.data?.error_data?.username[0];
      setError('phone_number', { message: responseErrors });
    });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <PhoneField
        label={t('shared.phone')}
        errors={errors}
        {...register('phone_number')}
        control={control}
      />
      <button
        type='submit'
        className='flex w-full justify-center rounded-md bg-primary px-3 py-2 text-base font-medium leading-6 text-white shadow-sm hover:bg-lime-600 disabled:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-600'
        disabled={loading}
      >
        {loading ? <Spinner /> : t('shared.continue')}
      </button>
    </form>
  );
}
